













import { Vue, Component } from 'vue-property-decorator'
import LinksStore from '../components/LinksStore.vue'
import scrollTo from '../mixins/scrollTo'

@Component({
  components: {
    LinksStore
  }
})

export default class MenuMobile extends Vue {
  menu = [ { hash: 'about', text: 'О самозанятых' }, { hash: 'plus', text: 'Преимущества' }, { hash: 'instructions', text: 'Стать самозанятым' },
           { hash: null, text: 'Портал поставщиков', link: 'https://partners.wb.ru/' } ]
  links = [
    { img: '/static/images/google-play.png', link: 'https://play.google.com/store/apps/details?id=com.wildberries.portal&hl=ru' },
    { img: '/static/images/app-store.png', link: 'https://apps.apple.com/ru/app/wb-%D0%BF%D0%B0%D1%80%D1%82%D0%BD%D1%91%D1%80%D1%8B/id1466739454' },
  ]

  onLinkClick(item) {
    if (item.hash) {
      if (this.$route.hash.slice(1) === item.hash) {
        this.$router.push({path: '/'}, () => this.$router.push({path: `/#${item.hash}`}))
      } else this.$router.push({path: `/#${item.hash}`})
    }
    else window.open(item.link, '_blank')

    this.$emit('closeMenu')
  }
}
